import React, { FC } from 'react'
import { Modal, Button } from 'antd'
import { ModalProps } from 'antd/lib/modal'
import { submit } from 'redux-form'
import { useDispatch } from 'react-redux'
import { FORM } from '../../utils/enums'
import CreateTemplateForm from '../forms/CreateTemplateForm'

// assets
import { ReactComponent as CloseIcon } from '../../assets/icons/BaseIcons/x-icon.svg'

type Props = ModalProps & {
	isVisible: boolean
	title: string
	onCancel: Function | React.MouseEvent<HTMLElement, MouseEvent>
	onConfirmBtnTitle: string
	handleSubmit: any
	disabled?: boolean
	classNameBtn?: string
}

const TemplateModal: FC<Props> = (props) => {
	const { isVisible, title, onCancel, width, onConfirmBtnTitle, classNameBtn, handleSubmit, disabled } = props

	const dispatch: any = useDispatch()

	return (
		<Modal
			closeIcon={<CloseIcon width={18} height={18} />}
			title={title}
			centered
			open={isVisible}
			width={width}
			onCancel={onCancel}
			footer={[
				<Button
					disabled={disabled || false}
					style={{ height: 40 }}
					className={classNameBtn}
					key='submit'
					type='primary'
					onClick={() => dispatch(submit(FORM.FORM_TEMPLATE))}
				>
					{onConfirmBtnTitle}
				</Button>
			]}
		>
			<CreateTemplateForm onSubmit={handleSubmit} />
		</Modal>
	)
}

export default TemplateModal
